import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: 'root'
})

export class TgeeASUManufacturerReportService {

    constructor(protected http: HttpClient) {

    }

    baseurl = environment.apiBaseUrl + 'TGEEReport';

    getAsuManufacturerReportData() {
        return this.http.get<any[]>(this.baseurl + '/getasumanufacturerreportdata');
    }

    getAsuManufacturerMapData() {
        return this.http.get<any[]>(this.baseurl + '/getasumanufacturermapdata');
    }

    // getASUAwardsReport(filter: SmrAndAsuAwardsReportFilter) {
    //     return this.http.post<any[]>(this.baseurl + '/GetASUAwardsReport', filter);
    // }
}